<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" acceptLabel="Oui" rejectLabel="Non"></p-confirmDialog> 
<div class="container-fluid">
<div class="row mh-100vh" style="height: 100vh;" #divLoginPage> 
  <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
    <div>
      <h3 class="text-center mt-0 m-b-15"> 
        <img src="assets/v2/img/CFN-LOGO-Sign-only.svg" height="60" alt="logo">
        Confirmer votre compte Coffre-fort numérique 
      </h3>
    
    <div class="center-screen container-login100 bodybg-color">            
        <p-card class="customCard">
          <p-header class="customHeader"> 
            <form action="#" novalidate>
              <span class="headerTitle" *ngIf="!isError && step == 1">
                <h3 class="mb-4">Question secrète</h3>
                <div class="alert alert-info messageInfo">
                  Pour une raison de sécurité, veuillez configurer une question secrète et saisir une réponse selon votre choix afin de confirmer votre espace coffre-fort numérique.
                  <br>
                  Vous aurez besoin de cette réponse pour échanger avec l'équipe support de coffre-fort numérique.
                </div> 
              </span>
              <div *ngIf="step == 1">
                <div class="alert alert-danger" *ngIf="submitted && isError">
                  Une erreur est survenue lors du traitement de votre demande.
                </div>
                <div class="row" style="padding-top:15px;justify-content: center;">
                  <app-question-security [ResponseModel]="responseModel" [submitted]="submitted" (validate)="isSecurityQuestionValid=$event"></app-question-security>
                </div>
                <div class="row" style="justify-content: center;">
                  <div class="col-md-4 col-connect-action">
                    <button style="font-weight: 14;" type="submit" class="btn btn-primary" (click)="save()">
                      <span class="btn-label">
                        <i class="pi pi-save"></i>
                      </span>Enregsitrer
                      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" style="color:#B22222;"
                            role="status" aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="step == 2">
                <div class="alert alert-info" *ngIf="submitted && !isError && isConfirmed" style="max-width:600px!important;">
                  Un lien vous a été envoyé sur votre adresse e-mail {{CryptedEmail}} afin de créer votre mot de passe Coffre-fort numérique. 
                  <button type="submit" class="btn btn-primary" (click)="redirectToLogin()">
                    <span class="btn-label">
                      <i class="pi pi-unlock"></i>
                    </span>Se connecter
                  </button>
                </div>
              </div>
            </form>
          </p-header>
        </p-card> 
    </div>
  </div>
  </div>
  <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
    <div></div>
  </div>
</div>
</div>
